module.exports = "https://health.dajiuxing.com.cn/img/assets/serviceImg/gjfw1 (1).png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=assets%2FserviceImg%2Fgjfw1%20(1).png
// module id = epcC
// module chunks = 93